import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Route, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { LocalStorageService } from '../core.module';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private localStorageService: LocalStorageService,
              private router: Router){

  }

  canActivate()
  {
    if(this.localStorageService.get('bearer') === null || this.localStorageService.isExpired('bearer')){
      this.localStorageService.remove('bearer');
      this.localStorageService.remove('email');
      this.localStorageService.remove('mobile_number');
      this.localStorageService.remove('authorized');
      this.localStorageService.remove('companyCode');
      this.router.navigateByUrl(`/`, { skipLocationChange: false });
      return false;
    }
    
    else{
      return true;
    }
  }
  
}
